var React = require('react');

function More (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.99975 2.24359C4.99975 3.48269 3.99526 4.48718 2.75616 4.48718C1.51706 4.48718 0.51257 3.48269 0.51257 2.24359C0.51257 1.00449 1.51706 0 2.75616 0C3.99526 0 4.99975 1.00449 4.99975 2.24359ZM4.9989 8.52564C4.9989 9.76474 3.99441 10.7692 2.75531 10.7692C1.51621 10.7692 0.511719 9.76474 0.511719 8.52564C0.511719 7.28654 1.51621 6.28205 2.75531 6.28205C3.99441 6.28205 4.9989 7.28654 4.9989 8.52564ZM2.75531 17.0513C3.99441 17.0513 4.9989 16.0468 4.9989 14.8077C4.9989 13.5686 3.99441 12.5641 2.75531 12.5641C1.51621 12.5641 0.511719 13.5686 0.511719 14.8077C0.511719 16.0468 1.51621 17.0513 2.75531 17.0513Z","fill":"#C4C4C4"}));
}

More.defaultProps = {"width":"5","height":"18","viewBox":"0 0 5 18","fill":"none"};

module.exports = More;

More.default = More;
